import { useOnlineStatus } from 'app/utils/hooks/useOnlineStatus'
import { useEffect, useState } from 'react'
import { Text, Theme, YStack } from 'tamagui'

export const OfflineBanner = () => {
  const isOnline = useOnlineStatus()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!isOnline) {
      setIsVisible(true)
    } else {
      const timeout = setTimeout(() => setIsVisible(false), 2000)
      return () => clearTimeout(timeout)
    }
  }, [isOnline])

  if (!isVisible) return null

  return (
 
      <YStack
        position={"sticky" as any}
        top={0}
        left={0}
        right={0}
        zIndex={9999} // Ensure banner appears above other content
        backgroundColor="$color7"
        paddingVertical="$2"
        alignItems="center"
        animation="quick"
        enterStyle={{ opacity: 0, y: -40 }}
        exitStyle={{ opacity: 0, y: -40 }}
        opacity={1}
        y={0}
      >
        <Text color="$color1" fontWeight="700" fontSize="$3" letterSpacing={-0.3}>
          You are currently offline
        </Text>
      </YStack>

  )
}